// import Work1 from "../../assets/work6.png";
import hrishi_portfolio from "../../assets/work8_hp_v2.png";
import hrishi_portfoli0_2 from "../../assets/work9_hp_v2.png";
import hrishi_portfolio_v1 from "../../assets/work7.png";
// import Work3 from "../../assets/work3.jpg";
import aiResumeArch from "../../assets/ai-resume-arch.png";
// import Work4 from "../../assets/work4.jpg";
// import Work5 from "../../assets/work5.jpg";

export const projectsData = [
  // {
  //   id: 1,
  //   image: Work1,
  //   title: "Web design",
  //   category: "web",
  //   link: "https://sidefolio-cytz4sbm9-yadavamitts-projects.vercel.app/resume",
  // },
  {
    id: 1,
    image: hrishi_portfoli0_2,
    title: "Web design",
    category: "web",
    link: "https://hrishi-portfolio-4612.vercel.app",
  },
  {
    id: 2,
    image: hrishi_portfolio_v1,
    title: "Web design",
    category: "web",
    link: "https://hrishi-portfolio-phi.vercel.app",
  },
  {
    id: 3,
    image: aiResumeArch,
    title: "Web design",
    category: "web",
    link: "https://ai-resume-architect.vercel.app",
  },
  // {
  //   id: 2,
  //   image: Work2,
  //   title: "App mobile",
  //   category: "app",
  // },
  // {
  //   id: 3,
  //   image: Work3,
  //   title: "Brand design",
  //   category: "design",
  // },
  // {
  //   id: 4,
  //   image: Work4,
  //   title: "App mobile",
  //   category: "App",
  // },
  // {
  //   id: 5,
  //   image: Work5,
  //   title: "Web design",
  //   category: "Web",
  // },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  // {
  //   name: "app",
  // },
  // {
  //   name: "design",
  // },
];
